/**
 * 请求层唯一入口
 *
 * 原来每个接口一份几乎相同的 axios 封装（lib/axios.js 主接口、lib/opAxios.js op 接口），
 * 现在合并到这一个文件里：这里只声明「服务 = 域名 + 请求体形态 + 认证方式」，
 * 请求实现只有一处出口 ./createHttpService.js，域名在 src/config/api.js 里按服务登记。
 *
 * 用法：
 *   import { service, opService } from '@/lib/request';
 *   service.post('/v1/xx', {...})    // 主接口：主域名 + 信封 { header, body }
 *   opService.post('/v1/xx', {...})  // op 接口：op 域名 + 参数平铺
 *
 * 新增一个域名：
 *   1）src/config/api.js 的 API_URLS 里给每个环境（prod/pre/test/local）加一项；
 *   2）这里加一行 createRequest('新服务名', { envelope, auth })。
 */
import createRequest from './createRequest';
import {
  ENVELOPE,
  http,
  httpRequest,
  checkStatus,
  shouldShowLoading,
  isAmapUrl
} from './createHttpService';

/** 主接口：主域名 + 信封 { header: { token, platform }, body: { ...业务参数 } } */
export const service = createRequest('main', {
  envelope: ENVELOPE.HEADER_BODY,
  // 保留原行为：改造前 opAxios.js 的拦截器挂在「全局 axios」上，
  // 因此主接口请求也一直带着 Authorization: Bearer。
  // 若确认主接口不需要这个头，删掉这行即可（token 仍在信封 header.token 里）
  auth: 'bearer'
});

/** op 接口：op 域名 + 参数平铺 + Authorization: Bearer */
export const opService = createRequest('op', {
  envelope: ENVELOPE.FLAT,
  auth: 'bearer'
});

/**
 * 电影接口（/v1/ju/movies/*）：信封与认证和主接口一致，只是域名单独登记 ——
 * 影片源只配在正式网关，测试网关返回 10003「没有找到影片源」（见 src/config/api.js 的 movie 服务）
 */
export const movieService = createRequest('movie', {
  envelope: ENVELOPE.HEADER_BODY,
  auth: 'bearer'
});

/**
 * 旅游景点接口（/v1、/v2 的 ctrip 目录/资源读接口）：景点数据只在正式网关齐全
 * （见 src/config/api.js 的 tour 服务）；下单/支付/退款仍用主接口 service
 */
export const tourService = createRequest('tour', {
  envelope: ENVELOPE.HEADER_BODY,
  auth: 'bearer'
});

// 出口工具：特殊请求（平铺 GET、静态资源等）需要时从这里取，避免绕开唯一出口
export {
  http,
  httpRequest,
  checkStatus,
  shouldShowLoading,
  isAmapUrl,
  ENVELOPE
};

export default service;
